// extracted by mini-css-extract-plugin
export default {"menubar":"menubar__11wHN","logo":"logo__3glFr","logobg":"logobg__2F2GX","icon":"icon__16cJK","icontext":"icontext__rbpId","active":"active__3v_b9"};